require '../../date_picker/frontend/date_picker'

bookingWidgetTemplate = require '../widget.html.mustache'

ROOT_URL = '/merchant-page/booking'
DESKTOP_WIDGET_WRAPPER_SELECTOR = '.mpp-container .main-content-right-column .booking-widget-wrapper'
MOBILE_WIDGET_WRAPPER_SELECTOR = '.mpp-container .main-content-left-column .booking-widget-wrapper'

fetchOpenings = (placeId, city, cb) ->
  request = $.get "#{ROOT_URL}/openings/#{city}/#{placeId}", (res) ->
    return cb('result-not-ok') unless res?.result is 'ok'
    openings = res.data
    cb null, openings

  request.fail ->
    cb 'request-failed'

getAvailablePartySizes = (openings) ->
  partySizes = {}
  for year, months of openings
    for month, days of months
      for day, dayData of days
        continue unless dayData.participants?
        for partySize, times of dayData.participants
          partySizes[partySize] = true
  partySizesArray = (parseInt(size) for size of partySizes)
  partySizesArray = partySizesArray.sort((a, b) -> a - b)

MPP.loadBookingWidget = ({placeId, user, csrf, city}) ->
  user = null unless user.maskedName?.length > 0 or user.primaryEmailAddress?.length > 0
  fetchOpenings placeId, city, (err, openings) ->
    today = new Date()
    year = today.getFullYear()
    return if err? or not (openings?[year]? or openings?[year + 1]?)

    partySizes = []
    partySizeNumbers = getAvailablePartySizes openings
    for size in partySizeNumbers
      partySizes.push
        size: size
        text: I18n.translate('js.modules.booking.widget.values.party_size', { count: size })

    templateData = { placeId, user, partySizes, csrf }
    templateData.translate = templateData.t = -> (text) -> I18n.translate text

    html = bookingWidgetTemplate.render templateData

    if $('.mpp-container .main-content-right-column').is(':visible')
      selector = DESKTOP_WIDGET_WRAPPER_SELECTOR
    else
      selector = MOBILE_WIDGET_WRAPPER_SELECTOR

    $(selector).html html

    new MPP.BookingWidget
      el: '.mpp-container section.booking-widget'
      placeId: placeId
      csrf: csrf
      city: city
      openings: openings
      isMobileView: selector is MOBILE_WIDGET_WRAPPER_SELECTOR

class MPP.BookingWidget

  constructor: ({@el, @placeId, @openings, @csrf, @city, @isMobileView}) ->
    @$el = $ @el
    @$loading = @$el.find '.loading'
    @$back = @$el.find '.back'
    @$jcarousel = @$el.find '.jcarousel'
    @$next = @$el.find 'button.next'
    @$complete = @$el.find 'button.complete'
    @$circles = @$el.find '.pagination .circle'
    @$partySize = @$el.find 'select.party-size'
    @$date = @$el.find 'input.date'
    @$datePicker = @$el.find '.date-picker'
    @$time = @$el.find 'select.time'
    @$firstName = @$el.find 'input.first-name'
    @$lastName = @$el.find 'input.last-name'
    @$phone = @$el.find 'input.phone'
    @$emailWrapper = @$el.find '.email-wrapper'
    @$email = @$el.find 'input.email'
    @$comment = @$el.find 'textarea.comment'
    @$emailError = @$el.find '.error-message.invalid-email'

    @isResponsive = $('.responsive .mpp-container').length > 0

    @$el.slideDown =>
      @initJCarousel()
      @initDatePicker()
      @initBindings()

  initDatePicker: ->
    @datePicker = new MPP.DatePicker { el: @$datePicker, input: @$date }

  initJCarousel: ->
    @step = 1

    width = @$jcarousel.outerWidth()
    @$jcarousel.find('li').css 'width', "#{width}px"

    @$jcarousel.jcarousel()

    $jcarouselUl = @$jcarousel.find 'ul'
    $jcarouselUl.css 'left', 0
    $jcarouselUl.scrollTo 0, { axis: 'x' }

  destroyJCarousel: ->
    @$jcarousel.data('jcarousel').destroy()

  track: (eventName) ->
    OptimizeSuite.TrackingHub.add eventName

  trackStep: (step) ->
    @visitedSteps or= {}
    return if @visitedSteps[step] is true
    @visitedSteps[step] = true
    @track "booking-widget:step-#{step}"

  moveToStep: (step, animate, cb) ->
    @$jcarousel.jcarousel 'scroll', step - 1, animate, (scrolled) =>
      return unless scrolled
      @step = step
      cb?()
    @trackStep step

  nextStep: ->
    @moveToStep @step + 1, true, =>
      @updateDisplay()

  previousStep: ->
    @moveToStep @step - 1, true, =>
      @updateDisplay()

  updateDisplay: ->
    @$circles.removeClass 'active'
    @$el.find(".pagination .page-#{@step}").addClass 'active'

    switch @step
      when 1
        @$back.hide()
        @validateStepOneFields()
        @$partySize.select()
      when 2
        @$back.show()
        @$next.show()
        @$complete.hide()
        @validateStepTwoFields()
        @$firstName.focus()
      when 3
        @swapButton()
        @$comment.focus()

  validateStepOneFields: ->
    return false unless @step is 1
    partySize = @getSelectedPartySize()
    parsedDate = @getSelectedDate()
    parsedTime = @getSelectedTime()
    if partySize? and parsedDate? and parsedTime?
      @$next.prop 'disabled', false
      return true
    else
      @$next.prop 'disabled', true
      return false

  validateStepTwoFields: ->
    return false unless @step is 2
    firstName = @getFirstName()
    lastName = @getLastName()
    phone = @getPhone()
    email = @getEmail()

    isValidEmailAddress = @isValidEmailAddress email

    if firstName.length > 0 and lastName.length > 0 and phone.length > 0 and isValidEmailAddress
      @hideEmailError()
      @$next.prop 'disabled', false
      return true
    else
      @hideEmailError() if isValidEmailAddress
      @$next.prop 'disabled', true
      return false

  showOrHideEmailError: ->
    email = @getEmail()
    if email.length > 0 and not @isValidEmailAddress(email)
      @showEmailError()
    else
      @hideEmailError()

  # emailRegex is a simple regular expression gotten from http://www.regular-expressions.info/email.html
  # It matches at least 1 character, then the @ symbol, then any number of characters, then a dot . and then 2-8 characters
  isValidEmailAddress: ->
    email = @getEmail()
    return false if @invalidEmailAddresses?[email]

    emailRegex = /^[^@]+@[^@]+\.[^@]{2,63}$/
    emailRegex.test email

  moveWidget: ->
    return unless @isResponsive

    if @isMobileView and $(DESKTOP_WIDGET_WRAPPER_SELECTOR).is(':visible')
      $(DESKTOP_WIDGET_WRAPPER_SELECTOR).html @$el
      $(MOBILE_WIDGET_WRAPPER_SELECTOR).find(@$el).remove()
      @isMobileView = false
    else if not @isMobileView and not $(DESKTOP_WIDGET_WRAPPER_SELECTOR).is(':visible')
      $(MOBILE_WIDGET_WRAPPER_SELECTOR).html @$el
      $(DESKTOP_WIDGET_WRAPPER_SELECTOR).find(@$el).remove()
      @isMobileView = true

  onResize: (step) ->
    clearTimeout(timer) if timer
    timer = setTimeout (=>
      @moveWidget()
      @destroyJCarousel()
      @initJCarousel()
      @moveToStep step, false
    ), 250

  initBindings: ->
    $(window).on 'resize', => @onResize @step

    @$next.click => @nextStep()

    @$back.click => @previousStep()

    @$complete.click => @submit()

    @$partySize.change =>
      @updateAvailableDates()
      @updateAvailableTimes()
      @validateStepOneFields()
      @$date.select() unless @getSelectedDate()?
      # after selecting the first option, we track that the user started using the widget
      @trackStep 1

    @$date.change =>
      @updateAvailableTimes()
      @validateStepOneFields()
      @$time.select() unless @getSelectedTime()?

    @$time.change =>
      @validateStepOneFields()

    @$el.find('.step-2 input').on 'keyup change', =>
      @validateStepTwoFields()

    @$email.on 'change blur', =>
      @validateStepTwoFields()
      @showOrHideEmailError()

    # Disable tab key from being entered.
    @$partySize.keydown (e) ->
      e.preventDefault() if e.keyCode is 9

    # Disable tab key from being entered.
    @$date.keydown (e) ->
      e.preventDefault() if e.keyCode is 9

    # Disable tab key from being entered.
    @$time.keydown (e) =>
      if e.keyCode is 9
        e.preventDefault()
        @$next.focus()

    # For shift+tab, move jcarousel back.
    @$firstName.keydown (e) =>
      if @step isnt 2
        e.preventDefault()
      if e.keyCode is 9 and event.shiftKey
        @previousStep()
        e.preventDefault()

    # If tab key entered and all data filled out, move jcarousel forward.
    @$phone.keydown (e) =>
      if @step isnt 2
        e.preventDefault()
      if e.keyCode is 9 and not event.shiftKey
        @$next.focus()
        e.preventDefault()

    # For shift+tab, move jcarousel back.
    @$comment.keydown (e) =>
      if @step isnt 3
        e.preventDefault()
      if e.keyCode is 9 and event.shiftKey
        @previousStep()
        e.preventDefault()

    @labelsBinding()

  labelsBinding: ->
    return if $('html.lt-ie10').length

    @$el.find('.input-wrapper.with-label').focusin (evt) ->
      $(evt.currentTarget).find('label').show()

    @$el.find('.input-wrapper.with-label').focusout (evt) ->
      $(evt.currentTarget).find('label').hide()

  showEmailError: ->
    @$emailWrapper.addClass 'error'
    @$email.addClass 'error'
    @$emailError.show()

  hideEmailError: ->
    @$emailWrapper.removeClass 'error'
    @$email.removeClass 'error'
    @$emailError.hide()

  submit: ->
    @showLoading()

    parsedDate = @getSelectedDate()
    data =
      participants: @getSelectedPartySize()
      date: "#{parsedDate?.year}-#{parsedDate?.month}-#{parsedDate?.day}"
      time: @getSelectedTime()
      first_name: @getFirstName()
      last_name: @getLastName()
      phone: @getPhone()
      email: @getEmail()
      comment: @getComment()
      _csrf: @csrf

    @trackStep 'submit'

    $.ajax
      url: "#{ROOT_URL}/book/#{@city}/#{@placeId}"
      type: 'POST'
      contentType: 'application/json'
      dataType: 'json'
      data: JSON.stringify data
      success: (res) =>
        if res.result is 'ok'
          @createAndSubmitConfirmationForm data
          return

        @hideLoading()

        if res.error?.code is 'invalid-email-address'
          @track 'booking-widget:error:reservation-failed:invalid-email'
          @invalidEmailAddresses or= {}
          @invalidEmailAddresses[@getEmail()] = true
          @moveToStep 2, true, =>
            @showOrHideEmailError()
            @updateDisplay()
            @$email.focus()
        else
          @track 'booking-widget:error:reservation-failed:unhandled'
          # TODO: handle this error in a not so ugly way.
          alert I18n.translate('js.modules.booking.widget.errors.booking')
      error: =>
        @hideLoading()
        @track 'booking-widget:error:failed-book-request'
        # TODO: handle this error in a not so ugly way.
        alert I18n.translate('js.modules.booking.widget.errors.booking')

  createAndSubmitConfirmationForm: (bookingData) ->
    form = document.createElement 'form'
    form.setAttribute 'method', 'POST'
    form.setAttribute 'action', "#{window.location.pathname}/booking/confirmation"

    $.each bookingData, (key, value) ->
      hiddenField = document.createElement 'input'
      hiddenField.setAttribute 'type', 'hidden'
      hiddenField.setAttribute 'name', key
      hiddenField.setAttribute 'value', value

      form.appendChild hiddenField

    document.body.appendChild form
    form.submit()

  showLoading: ->
    @$loading.show()

  hideLoading: ->
    @$loading.hide()

  getAvailableTimes: (parsedDate, partySize) ->
    return null unless parsedDate? and @openings?
    @openings[parseInt(parsedDate.year)]?[parseInt(parsedDate.month)]?[parseInt(parsedDate.day)]?.participants?[partySize] or []

  updateAvailableTimes: ->
    partySize = @getSelectedPartySize()
    parsedDate = @getSelectedDate()
    selectedTime = @getSelectedTime()

    @resetTimes()

    if not parsedDate? or not partySize?
      @$time.prop 'disabled', true
      return

    times = @getAvailableTimes parsedDate, partySize

    if not times?.length
      @$time.prop 'disabled', true
      return

    @$time.prop 'disabled', false

    # Add the new options
    html = ''
    for time in times
      html += "<option value=\"#{time}\">#{time}</option>"
    @$time.append html

    if selectedTime in times
      @$time.val selectedTime

  updateAvailableDates: ->
    partySize = @getSelectedPartySize()
    parsedDate = @getSelectedDate()

    @resetCalendar()

    if not partySize?
      @$time.prop 'disabled', true
      return

    dates = []
    for year, months of @openings
      for month, days of months
        month = "0#{month}" if month < 10
        for day, dayData of days
          day = "0#{day}" if day < 10
          dates.push("#{year}-#{month}-#{day}") if dayData.participants?[partySize]
    @datePicker.setValidDates dates

    @$date.prop 'disabled', false

    if @isValidPartySizeAndDate partySize, parsedDate
      @$date.val "#{parsedDate.day}/#{parsedDate.month}/#{parsedDate.year}"
    else
      @$date.click()

  isValidPartySizeAndDate: (partySize, parsedDate) ->
    return false unless partySize? and parsedDate?
    return true if @openings[parseInt(parsedDate.year)]?[parseInt(parsedDate.month)]?[parseInt(parsedDate.day)]?.participants?[partySize]
    return false

  resetCalendar: ->
    @$date.val ''
    return

  resetTimes: ->
    # Remove all option elements except the placeholder
    @$time.find('option').each (index, element) ->
      value = $(element).attr 'value'
      element.remove() unless value is ''
    @$time.val ''
    return

  resetPartySize: ->
    @$partySize.val ''
    return

  swapButton: ->
    @$next.hide()
    @$complete.show()

  parseDate: (date) ->
    matches = date?.match /^([0-9]{2})[-\/]([0-9]{2})[-\/]([0-9]{4})$/
    return null unless matches
    day = matches[1]
    month = matches[2]
    year = matches[3]
    { day, month, year }

  getSelectedPartySize: ->
    @$partySize.val()

  getSelectedDate: ->
    @parseDate @$date.val()

  getSelectedTime: ->
    @$time.val()

  getFirstName: ->
    @$firstName.val().trim()

  getLastName: ->
    @$lastName.val().trim()

  getPhone: ->
    @$phone.val().trim()

  getEmail: ->
    @$email.val().trim()

  getComment: ->
    @$comment.val().trim()

$ ->
  $el = $ '.booking-widget-wrapper'
  return unless $el.length > 0

  place = $('.mpp-container').data()
  bookingConfig = $el.data()
  csrfToken = $('meta[name=csrf-token]').attr('content')

  merchantSlug = window.location.pathname.match(/\/biz\/(.+)/)?[1]
  city = merchantSlug?.split('/')[0]

  MPP.loadBookingWidget({
    placeId: place.placeId,
    user: {
      maskedName: bookingConfig.userMaskedName,
      primaryEmailAddress: bookingConfig.userPrimaryEmailAddress
    },
    csrf: csrfToken,
    city
  })
